import EventEmitter from './libs/EventEmitter.js'

export const ACTION = {
	'RESIZE': 'resize',
    'SCROLL': 'scroll',
    'DOM_READY': 'dom_ready',
    'CLICK_MOBILE_NAV_TRIGGER': 'click_mobile_nav_trigger',
    'NAV_SHOW_HIDE': 'nav_show_hide',
    'IMAGES_LOADED': 'images_loaded',
    'MENU_COMPACT_ACTIVE': 'menu_compact_active',
    'MENU_COMPACT_INACTIVE': 'menu_compact_inactive',
    'MENU_PINNED_ACTIVE': 'menu_pinned_active',
    'MENU_PINNED_INACTIVE': 'menu_pinned_inactive',
    'HEADER_ANIMATION_FINISHED': 'header_animation_finished',
    'TOGGLE_NEWSLETTER_MODAL': 'toggle_newsletter_modal'
}

export const Events = new EventEmitter()